import React from 'react';
import styled from 'styled-components';
import SearchIcon from '@material-ui/icons/Search';
import Badge from '@material-ui/core/Badge';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import {mobile} from "../Responsive"
import {Link} from 'react-router-dom'


const Container = styled.div`
    height: 60px;
    background-color: #4c4073;
    ${mobile({height: "50px"})}
`
const Wrapper = styled.div`
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${mobile({padding: "10px 0"})}
`

const Left = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;    
    align-items: center;
`

const Language = styled.div`
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;

`
const SearchContainer = styled.div`
    border: 1px solid lightgrey;
    display: flex;
    justify-content: center;    
    align-items: center;
    margin-left: 25px;
    padding: 5px;
`
const Input = styled.input`
    border: none;
    ${mobile({width: "55px"})}
`
const Logo = styled.h1`
    font-weight: bolder;
    font-family: 'Lucida Sans';
    ${mobile({fontSize: "25px"})}
    cursor: pointer;
    color: black;
    text-decoration-style: none;
`

const Center = styled.div`
    flex: 1;
    text-align: center;
    text-decoration: none;
`
const Right = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ${mobile({justifyContent: "center"})}
`
const MiniItem = styled.div`
    font-size: 14;
    cursor: pointer;
    margin-left: 25px;
    color: black;
    text-decoration: none;
`

const LinkStyle = {
    color:"black",
    textDecoration: "none"
}


const Navbar = () => {
    return (
        <Container>
            <Wrapper>
                <Left>
                    <Language >
                        En
                    </Language>
                    <SearchContainer >
                        <Input placeholder="Search" />
                        <SearchIcon style={{color:"gray", fontSize:18}} />
                    </SearchContainer>
                </Left>
                <Center>
                    <Link style={LinkStyle} to="/">
                        <Logo >
                            LIN.
                        </Logo>
                    </Link>
                </Center>
                <Right>
                    <Link style={LinkStyle} to='/register' >
                        <MiniItem >
                                Register
                        </MiniItem>
                    </Link>
                    <Link style={LinkStyle} to='/login' >
                        <MiniItem >
                            Login
                        </MiniItem>
                    </Link>
                    <MiniItem >
                        <Link style={LinkStyle} to='/cart' >
                            <Badge badgeContent={3} >
                                <ShoppingCartOutlinedIcon />
                            </Badge>
                        </Link>
                    </MiniItem>
                </Right>
            </Wrapper>
        </Container>
    )
}

export default Navbar
